/**
 * SAP CONFIDENTIAL 
 *
 * This software is confidential proprietary software licensed by SAP SE 
 * and is not to be used, duplicated or disclosed to anyone without the 
 * prior written permission of SAP. 
 *
 * (C) 2020 Copyright SAP SE.
 */
import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { CommonService } from '../services/common.service';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  templateUrl: './alert-modal.component.html',
//   styleUrls: ['./alert-modal.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class AlertModalComponent {
  @Input() configObj: any = {};
  @Input() isFromEligibilityReset: boolean = false;
  @Output() onClose = new EventEmitter<any>();

  constructor(public bsModalRef: BsModalRef, private commonService: CommonService) {}

  public getTranslationWithKey(key: string) {
    return this.commonService.getTranslatedVal(key);
  }

  public closeModalWindow(event: any) {
    event.stopPropagation();
    this.onClose.emit('closed');
    this.bsModalRef.hide();
  }
}
